export const formatPKR = (n) => (n == null || n === "" ? null : `PKR ${Number(n).toLocaleString("en-PK")}`);

export const fromPrice = (vehicle) => {
  const prices = (vehicle?.variants || []).filter((v) => v.price && v.price_label !== "Add-on").map((v) => v.price);
  return prices.length ? Math.min(...prices) : null;
};

export const waLink = (number, text) =>
  `https://wa.me/${String(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(text || "")}`;

export const telLink = (phone) => `tel:${String(phone || "").replace(/[^\d+]/g, "")}`;

export const slugify = (s) =>
  String(s || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("en-PK", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const pad2 = (n) => String(n).padStart(2, "0");
